import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const MaskLine = ({ children, delay = 0, inView = false, className = "" }) => {
  const trigger = inView
    ? { whileInView: "show", viewport: { once: true, amount: 0 } }
    : { animate: "show" };
  return (
    <motion.span initial="hidden" {...trigger} className={`block overflow-hidden pb-[0.06em] ${className}`}>
      <motion.span
        className="block"
        variants={{ hidden: { y: "110%" }, show: { y: "0%" } }}
        transition={{ duration: 1.1, ease: EASE, delay }}
      >
        {children}
      </motion.span>
    </motion.span>
  );
};

export const Eyebrow = ({ children, testid }) => (
  <p data-testid={testid} className="font-mono text-xs uppercase tracking-[0.25em] text-[var(--cyan)] flex items-center gap-3">
    <span className="h-px w-8 bg-[var(--cyan)]" />
    {children}
  </p>
);
